import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import * as VueGoogleMaps from 'vue2-google-maps';
import DatetimePicker from 'vuetify-datetime-picker';
import Toasted from 'vue-toasted';

Vue.use(Toasted, {
  iconPack : 'mdi'
});

Vue.use(DatetimePicker);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBN6V4HI2g6_iOMvglXy3ETqXXBuFaGnUI',
    libraries: 'places,drawing,visualization'
  },
  installComponents: true
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
